import React from "react";

function ProjectCards({ imgPath, title, context, description, ghLink, demoLink }) {
  return (
    <article className="case">
      <div className="case-copy">
        {context && <p className="case-context">{context}</p>}
        <h2 className="case-title">{title}</h2>
        <p className="prose">{description}</p>
        <p className="case-links">
          {ghLink && (
            <a href={ghLink} target="_blank" rel="noreferrer">
              Source
            </a>
          )}
          {demoLink && (
            <>
              <span aria-hidden="true"> · </span>
              <a href={demoLink} target="_blank" rel="noreferrer">
                Live
              </a>
            </>
          )}
        </p>
      </div>
      {imgPath && (
        <figure className="case-figure">
          <img src={imgPath} alt="" />
        </figure>
      )}
    </article>
  );
}

export default ProjectCards;
